import { useLayoutEffect } from "react";
import { setPageTitle } from "api";

const usePageTitle = (title) => {
  useLayoutEffect(() => {
    setPageTitle(title);
    document.title = title;
  }, [title]);
};

export default usePageTitle;
